// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "62ff0931c8f09d1abb6d6415857b1aab31c5d09b/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};